import React from 'react';

import RecordPaymentIcon from '../../Assets/General/RecordPaymentIcon';

import Email from '../../Components/Email/Email';
import { t } from 'i18next';

const CustomerPaymentEmail = (props) => {
  return (
    <Email
      {...props}
      Icon={RecordPaymentIcon}
      name={t('Payments.customer_payment')}
      onCancelURL="/paymentsmade"
      emailAPI={`advancepayment/${props.match.params.id}/mail`}
      fetchDataAPI={`advancepayment/${props.match.params.id}/mail`}
      getBackTab
    />
  );
};

export default CustomerPaymentEmail;
